<template>
  <div class="tab-content">

    <el-tabs activeName="first">
      <el-tab-pane :label="$t('vendor_tab_files_first')" name="first">
        <el-card>

          <el-table
            :data="meetingsList"
            style="width: 100%">
            <el-table-column
              label="Start">
              <template slot-scope="scope">
                {{moment(scope.row.startTimestamp * 1000).format("D MMM YY")}}
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="Meeting">
            </el-table-column>
            <el-table-column
              label="Status">
              <template slot-scope="scope">
                {{scope.row.status === 1 ? 'CREATED' : null}}
                {{scope.row.status === 2 ? 'STARTED' : null}}
                {{scope.row.status === 3 ? 'COMPLETED' : null}}
              </template>
            </el-table-column>
          </el-table>

        </el-card>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'

  export default  {
    name: 'vendor-persons-meetings',
    props: [],
    components: {},
    data() {
      return {
        moment:moment,
        meetingsList: [],
      }
    },
    methods:{
      loadList() {
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        axios.get(`/api/v1/client-vendor/meeting?entityId=${this.$route.query.companyClientPersonId}&entityType=clientPerson`)
          .then(response => {
            this.meetingsList = response.data.list
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
.add-comment-btn{
  margin-bottom:15px;
}
.box-card{
  margin: 10px 0;
}
.sweet-modal-overlay{
  z-index:1000;
}
.card__status{
  display:flex;
  align-items: center;
}
.photo-group{
  overflow:hidden;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 20px;
  background: url('~@/assets/img/user-default.jpg');
  background-size: cover;
  img{
    width:100%;
    height:100%;
  }
}
.flex-twocolumn{
  display:flex;
  .el-form-item__content{
    margin:0 12px;
    font-size:13px;
    &:first-child {
      margin-left: 0px;
    }
  }
}
/deep/ ul.el-timeline {
  padding-inline-start: 0px;
}

.text {
  position: relative;
  font-size: 14px;
}

.hovered-node{
  -webkit-box-shadow: 0 0 26px 5px #409EFF;
  box-shadow: 0 0 10px 5px #409EFF;
}
</style>
